import type { CSSProperties } from 'react';

import type { TemplateSurfacePalette } from '@/app/dashboard/templates/components/lib/templateExperience';
import { toHslTriplet } from '@/lib/menu-themes/hsl';

/** Rebind guest sheet portals to the branch palette; Radix portals sit under body. */
export function guestV2PaletteVars(
  palette: TemplateSurfacePalette,
  mode: 'light' | 'dark',
): CSSProperties {
  const table = palette.background;
  const paper = palette.card;
  const sunk = palette.muted;
  const ink = palette.foreground;
  const soft = palette.mutedForeground;
  const rule = palette.border;
  const accent = palette.accent;
  const accentInk = palette.accentForeground;
  const hsl = (color: string) => toHslTriplet(color);
  return {
    colorScheme: mode,
    background: paper,
    color: palette.cardForeground,
    '--chow-table': hsl(table),
    '--chow-paper': hsl(paper),
    '--chow-subtle': hsl(paper),
    '--chow-sunk': hsl(sunk),
    '--chow-ink': hsl(ink),
    '--chow-soft': hsl(soft),
    '--chow-faint': hsl(soft),
    '--chow-rule': hsl(rule),
    '--chow-leaf': hsl(accent),
    '--chow-ember': hsl(accent),
    '--chow-accent': hsl(accent),
    '--chow-accent-ink': hsl(accentInk),
    '--chow-accent-wash': hsl(sunk),
    '--chow-accent-ring': hsl(accent),
    '--background': hsl(table),
    '--foreground': hsl(ink),
    '--card': hsl(paper),
    '--card-foreground': hsl(palette.cardForeground),
    '--popover': hsl(paper),
    '--popover-foreground': hsl(palette.cardForeground),
    '--primary': hsl(accent),
    '--primary-foreground': hsl(accentInk),
    '--secondary': hsl(sunk),
    '--secondary-foreground': hsl(palette.mutedForeground),
    '--muted': hsl(sunk),
    '--muted-foreground': hsl(palette.mutedForeground),
    '--accent': hsl(accent),
    '--accent-foreground': hsl(accentInk),
    '--border': hsl(rule),
    '--input': hsl(rule),
    '--ring': hsl(accent),
    '--color-bg-base': table,
    '--color-bg-surface': paper,
    '--color-bg-surface-hover': `color-mix(in srgb, ${ink} 7%, ${paper})`,
    '--color-bg-sunken': sunk,
    '--color-border-subtle': rule,
    '--color-border-default': rule,
    '--color-text-primary': palette.cardForeground,
    '--color-text-secondary': soft,
    '--color-accent': accent,
    '--color-accent-text': accentInk,
    '--color-brand': palette.primary,
    '--color-brand-soft': `color-mix(in srgb, ${palette.primary} 12%, transparent)`,
    '--color-brand-border': `color-mix(in srgb, ${palette.primary} 28%, transparent)`,
    '--pub-surface-base': sunk,
    '--pub-surface-card': paper,
    '--pub-text-primary': palette.cardForeground,
    '--pub-text-secondary': soft,
    '--pub-text-muted': soft,
    '--pub-border-subtle': rule,
    '--pub-ember-fill': accent,
    '--pub-ember-text': accentInk,
  } as CSSProperties;
}
